if (!customElements.get("gift-popup")) {
  customElements.define(
    "gift-popup",

    class GiftPopup extends HTMLElement {
      constructor() {
        super();
        this.productTypeStep = this.querySelector(".gift-popup--progress-step--product-type");
        this.animalStep = this.querySelector(".gift-popup--progress-step--animal");
        this.colorStep = this.querySelector(".gift-popup--progress-step--color");
        this.products = this.productTypeStep.querySelectorAll(".gift-popup--progress-step__step-product");
        this.animals = this.animalStep.querySelectorAll(".gift-popup--progress-step__step-animal");
        this.progressSteps = this.querySelectorAll(".gift-popup--progress-step");
        this.addToCartBtn = this.querySelector(".gift-popup--add-to-cart-button");
        this.loader = this.addToCartBtn.querySelector(".lds-dual-ring");
        this.atcText = this.addToCartBtn.querySelector(".gift-popup--add-to-cart-button--text");
        this.atcPrices = this.addToCartBtn.querySelector(".gift-popup--progress-step__step-button--prices");
        this.cartCount = document.querySelector(".cart-item-count-header--quantity");
        this.cartDrawer = document.querySelector("#cartSlideoutWrapper");
        this.cartDrawerBtn = document.querySelector("#button-trigger-cart");
        this.dialog = document.querySelector("#gift-popup--dialog");
      }

      connectedCallback() {
        this.productTypeStep.querySelectorAll('input[name="gift-popup--product-type"]').forEach((input) => {
          input.addEventListener("change", this.handleProductTypeChange.bind(this));
        });
        this.productTypeStep.querySelector("button").addEventListener("click", this.handleProductTypeCompleted.bind(this));
        this.animalStep.querySelectorAll('input[name="gift-popup--animal"]').forEach((input) => {
          input.addEventListener("change", this.handleAnimalChange.bind(this));
        });
        this.animalStep.querySelector("button").addEventListener("click", this.handleAnimalCompleted.bind(this));
        this.addToCartBtn.addEventListener("click", this.addToCart.bind(this));
        document.addEventListener("cart-drawer-update", this.handleCartDrawerUpdate.bind(this));
      }

      disconnectedCallback() {
        this.productTypeStep.querySelectorAll('input[name="gift-popup--product-type"]').forEach((input) => {
          input.removeEventListener("change", this.handleProductTypeChange.bind(this));
        });
        this.productTypeStep.querySelector("button").removeEventListener("click", this.handleProductTypeCompleted.bind(this));
        this.animalStep.querySelectorAll('input[name="gift-popup--animal"]').forEach((input) => {
          input.removeEventListener("change", this.handleAnimalChange.bind(this));
        });
        this.animalStep.querySelector("button").removeEventListener("click", this.handleAnimalCompleted.bind(this));
        this.addToCartBtn.removeEventListener("click", this.addToCart.bind(this));
        document.removeEventListener("cart-drawer-update", this.handleCartDrawerUpdate.bind(this));
      }

      handleCartDrawerUpdate(event) {
        const itemCount = event.detail.item_count;
        if (itemCount == 2 && window.deployer.popupTest === true) {
          this.dialog.showModal();
        }
      }

      handleProductTypeChange(event) {
        this.productTypeStep.querySelector(".gift-popup--progress-step__step-choice").classList.remove("hidden");
        this.productTypeStep.querySelector(".gift-popup--progress-step__step-choice-selected").innerText = event.target.value;
        this.translateElement(this.productTypeStep.querySelector(".gift-popup--progress-step__step-choice-selected"));
        this.productTypeStep.querySelector("button").removeAttribute("disabled");
        this.progressSteps[0].classList.add("gift-popup--progress-step--completed");
        this.dataset.productType = event.target.id;
        this.products.forEach((product) => {
          product.classList.remove("gift-popup--progress-step__step-product--selected");
        });
        event.target.nextElementSibling.classList.add("gift-popup--progress-step__step-product--selected");
      }

      handleAnimalChange(event) {
        this.animalStep.querySelector(".gift-popup--progress-step__step-choice").classList.remove("hidden");
        this.animalStep.querySelector(".gift-popup--progress-step__step-choice-selected").innerText = event.target.value;
        this.translateElement(this.animalStep.querySelector(".gift-popup--progress-step__step-choice-selected"));
        this.animalStep.querySelector("button").removeAttribute("disabled");
        this.progressSteps[1].classList.add("gift-popup--progress-step--completed");
        this.dataset.animal = event.target.value;
        this.animals.forEach((animal) => {
          animal.classList.remove("gift-popup--progress-step__step-animal--selected");
        });
        event.target.nextElementSibling.classList.add("gift-popup--progress-step__step-animal--selected");
      }

      handleAnimalCompleted() {
        this.animalStep.classList.add("gift-popup--progress-step--animal--completed");
        setTimeout(() => {
          this.animalStep.classList.add("hidden");
          this.showNextStep(this.animalStep);
          this.initColorStep();
        }, 400);
      }

      handleProductTypeCompleted() {
        this.productTypeStep.classList.add("gift-popup--progress-step--product-type--completed");
        setTimeout(() => {
          this.productTypeStep.classList.add("hidden");
          this.showNextStep(this.productTypeStep);
        }, 400);
      }

      showNextStep(element) {
        element.nextElementSibling.classList.remove("hidden");
      }

      initColorStep() {
        const selectedProductType = this.querySelector(`script[data-collection-id="${this.dataset.productType}"]`);

        if (selectedProductType) {
          try {
            const products = JSON.parse(selectedProductType.textContent);

            const selectedAnimal = products.find((product) => product.animal_type.toLowerCase() === this.dataset.animal.toLowerCase());

            if (selectedAnimal) {
              const selectedAnimalVariants = Array.from(selectedAnimal.variants);
              selectedAnimalVariants.forEach((variant) => {
                if (selectedAnimalVariants.length > 1) {
                  this.createColorOption(variant, null);
                } else {
                  this.createColorOption(variant, selectedAnimal);
                }
              });
            } else {
              console.log(`Produit non trouvé: ${this.dataset.animal}`);
            }
          } catch (error) {
            console.error("Erreur lors du parsing JSON :", error);
          }
        } else {
          console.log("Le script JSON avec data-collection-id correspondant n'a pas été trouvé.");
        }
      }

      handleColorOptionChange(event) {
        this.colorStep.querySelector(".gift-popup--progress-step__step-choice").classList.remove("hidden");
        this.colorStep.querySelector(".gift-popup--progress-step__step-choice-selected").innerText = event.target.value;
        this.translateElement(this.colorStep.querySelector(".gift-popup--progress-step__step-choice-selected"));
        this.colorStep.querySelector("button").removeAttribute("disabled");
        this.progressSteps[2].classList.add("gift-popup--progress-step--completed");
        this.querySelectorAll(".gift-popup--progress-step__step-color").forEach((color) => {
          color.classList.remove("gift-popup--progress-step__step-color--selected");
        });
        event.target.nextElementSibling.classList.add("gift-popup--progress-step__step-color--selected");
        this.querySelector('input[name="gift-popup--variant-id"]').value = event.target.id;
        this.querySelector(".gift-popup--progress-step__step-button--prices").classList.remove("hidden");
        this.querySelector(".gift-popup--progress-step__step-button--compare-at-price").innerText = formatPrice(event.target.dataset.compareAtPrice);
        this.querySelector(".gift-popup--progress-step__step-button--price").innerText = formatPrice(event.target.dataset.price);
      }

      createColorOption(variant, selectedAnimal) {
        const colorOption = document.createElement("input");
        colorOption.type = "radio";
        colorOption.name = "gift-popup--color";
        colorOption.id = variant.id;
        colorOption.dataset.compareAtPrice = variant.compare_at_price;
        colorOption.dataset.price = variant.price;
        colorOption.value = selectedAnimal ? selectedAnimal.title : variant.title;
        colorOption.addEventListener("change", this.handleColorOptionChange.bind(this));
        this.querySelector(".gift-popup--progress-step__step-colors").appendChild(colorOption);
        const colorOptionLabel = document.createElement("label");
        colorOptionLabel.setAttribute("for", variant.id);
        colorOptionLabel.classList.add("gift-popup--progress-step__step-color");
        colorOptionLabel.innerHTML = `
          <div class="gift-popup--progress-step__step-color-image">
            <img
              src="${selectedAnimal ? selectedAnimal.image : variant.featured_image}"
              width="200"
              height="auto"
              alt="${selectedAnimal ? selectedAnimal.title : variant.title}"
            >
          </div>
          <div class="gift-popup--progress-step__step-color-title">
            ${selectedAnimal ? selectedAnimal.title : variant.title}
          </div>
        `;
        this.translateElement(colorOptionLabel.querySelector(".gift-popup--progress-step__step-color-title"));
        this.querySelector(".gift-popup--progress-step__step-colors").appendChild(colorOptionLabel);
      }

      async addToCart() {
        this.atcText.classList.add("hidden");
        this.loader.classList.remove("hidden");
        this.atcPrices.classList.add("hidden");
        const variantId = this.querySelector('input[name="gift-popup--variant-id"]').value;
        let formData = {
          items: [
            {
              id: variantId,
              quantity: 1,
            },
          ],
        };

        try {
          const fetchResult = await window.fetch("/cart/add.js", {
            method: "POST",
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          });

          const responseJson = await fetchResult.json();

          if (!fetchResult.ok) {
            console.error("Unable to add to cart: ", responseJson);
          } else {
            this.updateCart();
            return responseJson;
          }
        } catch (e) {
          console.error("Unable to add to cart: ", e);
        }
      }

      async updateCart() {
        const cart = await (await fetch("/cart.js")).json();
        window.wetheme.cartDrawer.updateCartDrawer(cart);
        if (this.cartDrawer.classList.contains("slideout-panel-hidden")) {
          setTimeout(() => {
            this.cartDrawerBtn.click();
          });
        }
        this.hideGiftPopup();
      }

      hideGiftPopup() {
        const buttons = this.querySelectorAll(".gift-popup--progress-step__step-button");
        const valuesSelected = this.querySelectorAll(".gift-popup--progress-step__step-choice-selected");
        const valuesStepsSelected = this.querySelectorAll(".gift-popup--progress-step__step-product--selected");
        const colors = this.querySelector(".gift-popup--progress-step__step-colors");
        const animalSelected = this.querySelector(".gift-popup--progress-step__step-animal--selected");
        animalSelected.classList.remove("gift-popup--progress-step__step-animal--selected");
        this.animalStep.classList.remove("gift-popup--progress-step--animal--completed");
        this.colorStep.classList.remove("gift-popup--progress-step--product-type--completed");
        this.animalStep.classList.add("hidden");
        this.colorStep.classList.add("hidden");
        this.productTypeStep.classList.remove("gift-popup--progress-step--product-type--completed");
        this.productTypeStep.classList.remove("hidden");
        this.productTypeStep.style.display = "flex";
        buttons.forEach((button) => {
          button.setAttribute("disabled", true);
        });
        valuesSelected.forEach((value) => {
          value.innerHTML = "";
        });
        this.progressSteps.forEach((step) => {
          step.classList.remove("gift-popup--progress-step--completed");
        });
        valuesStepsSelected.forEach((value) => {
          value.classList.remove("gift-popup--progress-step__step-product--selected");
        });
        // empty the colors div
        colors.innerHTML = "";
        this.atcText.classList.remove("hidden");
        this.loader.classList.add("hidden");
        this.atcPrices.classList.add("hidden");
        this.dialog.close();
      }

      translateElement(element) {
        const currentLang = Weglot.getCurrentLang();
        Weglot.translate(
          {
            words: [{ t: 1, w: element.innerText }],
            languageTo: currentLang,
          },
          function (data) {
            element.innerText = data;
          }
        );
      }
    }
  );
}
